<template>
    <div class="marketing-leads-award-location">
        <div class="position-display" :style="{ color: textColor }">
            <template v-if="!isInitializedLocationPrivate">
                点击按钮可获取位置信息
            </template>
            <template v-else-if="isInit || distance === undefined">
                <span v-if="isInit || isInitLocationPrivate">
                    授权定位后才可参与活动哦～
                </span>
                <span v-else>
                    退出页面重新进入授权定位后才可参与活动哦～
                </span>
            </template>
            <template v-else>
                <span>
                    距离{{ locationName }} | {{ distanceDisplay }}
                </span>
            </template>
        </div>
    </div>
</template>

<script>
import awardLocationMixin from '../../mixin/award-location';

export default {
    mixins: [awardLocationMixin],
    props: {
        textColor: {
            type: String,
            default: '#050B27'
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-leads-award-location {
    .position-display {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12 * @layout375;
        line-height: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/leads-award/award-location.vue